import { ROLE_LEVELS, useAuthLevel } from '../../../hooks/useCurrentUser';
import { cn } from '../../../lib/cn';
import { useListTicketsQuery } from '../tickets.api';
import { isOverdue } from '../tickets.schema';

// Live "my open tickets" count on the Tickete nav item — red when something is
// overdue. Polls so the nag stays current while the app sits open; the query
// args match MyTicketsPanel's so both share one cache entry (one request).
export function TicketNavBadge() {
    const level = useAuthLevel();
    const { data } = useListTicketsQuery(
        { mine: true, status: ['open', 'in_progress'], limit: 100 },
        { skip: (level ?? 0) < ROLE_LEVELS.MANAGER, pollingInterval: 90_000 },
    );
    const count = data?.count ?? 0;
    if (count === 0) return null;
    const hasOverdue = (data?.data ?? []).some(isOverdue);
    return (
        <span
            className={cn(
                'ml-auto inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold',
                hasOverdue
                    ? 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'
                    : 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
            )}
        >
            {count > 99 ? '99+' : count}
        </span>
    );
}
